import React from 'react';
import { Container } from '@mui/material';
import BCBAUtilizationCalculator from '../components/BCBAUtilizationCalculator';

const BCBAUtilizationCalculatorPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <BCBAUtilizationCalculator />
    </Container>
  );
};

export default BCBAUtilizationCalculatorPage;